<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
      style="height: 100%">
      <el-dialog title="角色管理" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="角色名称" prop="jsmc">
              <el-input type="type" placeholder="角色名称" class="from-el-input" v-model.trim="ruleForm.jsmc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="角色编码" prop="jsbm">
              <el-input type="type" placeholder="角色编码" class="from-el-input" v-model.trim="ruleForm.jsbm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item type="type" label="备注信息" prop="bzxx">
              <el-input type="type" placeholder="备注信息" class="from-el-input" v-model.trim="ruleForm.bzxx"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="margin-left: 32px;">权限</p>
          </el-col>
          <el-col :span="24">
            <div style="padding: 10px 4%;width: 92%;max-height: 350px;overflow: auto;">
              <el-tree ref="treeList" show-checkbox :data="datatree" class="paddingtree" :expand-on-click-node="false"
                :highlight-current='true' :default-expand-all="true" :props="defaultProps" node-key='id'
                :default-expanded-keys='[treesid]'>
              </el-tree>
            </div>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
            <el-button round v-if="state=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    roleinfo,
    menulist,
    rolesave,
    roleupdate
  } from "@/api/api";


  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        dialogVisible: true,
        ruleForm: {
          jsmc: '',
          jsbm: '',
          bzxx: '',

        },
        rules: {
          jsmc: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: "长度在 1 到 50 个字符",
              trigger: "blur"
            }
          ],
          jsbm: [{
              required: true,
              message: "请输入必填项",
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: "长度在 1 到 50 个字符",
              trigger: "blur"
            }
          ],
          bzxx: [{
              required: false,
              message: "请输入必填项",
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: "长度在 1 到 50 个字符",
              trigger: "blur"
            }
          ],
        },
        datatree: [],
        defaultProps: { /// tree设置
          children: 'children',
          label: 'name'
        },
        treesid: '',
        state: '',
        row: null,

      };
    },
    created() {
      //初始化数据
    },
    components: {},
    methods: {
      cancel() {

      },
      deteRmine(formName, type) {
        this.$refs[formName].validate(valid => {
          if (valid) {

            if (type == 'xz') {
              let checkboxlist = [];
              for (let i = 0; i < this.$refs.treeList.getCheckedNodes(1).length; i++) {
                checkboxlist.push(this.$refs.treeList.getCheckedNodes(1)[i].id)
              }

              let params = {
                roleName: this.ruleForm.jsmc,
                roleCode: this.ruleForm.jsbm,
                remark: this.ruleForm.bzxx,
                menuIdList: checkboxlist
              }
              rolesave(params).then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: "提交成功",
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.$emit("adddata", {
                    dialogVisible: this.dialogVisible
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            } else {
              let checkboxlist = [];
              for (let i = 0; i < this.$refs.treeList.getCheckedNodes().concat(this.$refs.treeList
                  .getHalfCheckedNodes()).length; i++) {
                checkboxlist.push(this.$refs.treeList.getCheckedNodes().concat(this.$refs.treeList
                  .getHalfCheckedNodes())[i].id)
              }

              let params = {
                roleName: this.ruleForm.jsmc,
                roleCode: this.ruleForm.jsbm,
                remark: this.ruleForm.bzxx,
                menuIdList: checkboxlist,
                id: this.row.id
              }
              roleupdate(params).then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.$emit("bjadddata", {
                    dialogVisible: this.dialogVisible
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            }

          } else {
            this.$notify({
              title: '提示',
              message: '请填写完整后再提交',
              type: 'warning'
            })
            return false
          }
        });
      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleNodeClick() {

      },

    },
    mounted() {
      this.state = this.mystate[0];

      menulist({}).then((res) => {
        // console.log(res)
        this.datatree = res.data;
        if (this.state == 'bj') {
          this.row = this.mystate[1];
          this.ruleForm.jsmc = this.row.roleName;
          this.ruleForm.jsbm = this.row.roleCode;
          this.ruleForm.bzxx = this.row.remark;
          roleinfo({
            roleId: this.row.id
          }).then((res) => {
            // console.log(res.role.menuIdList)
            this.$nextTick(function() {
              this.$refs.treeList.setCheckedKeys(res.role.menuIdList);
            })
          })
        }
      });
    }
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 700px;
  }

  >>>.el-dialog__body {
    max-height: 550px;
    overflow: auto;
  }

  .trees {
    width: 98%;
    float: left;
    max-height: 300px;
    height: 60px;
    line-height: 30px;
    padding-left: 2%;
    margin-top: 5px;
  }
</style>
